import { scriptsApi } from '../client'

export interface FacebookResolveResponse {
  reel_id: string | null
  canonical_url: string | null
}

export const facebookApi = {
  resolveReel: (url: string): Promise<FacebookResolveResponse> =>
    scriptsApi.post('/facebook/resolve-reel', { url }).then((r) => r.data),
}
